// @flow
import CafeteriaMenu from './CafeteriaMenu';

export default CafeteriaMenu;
